import classNames from 'classnames'
import React from 'react'
import c from '../../classnames.scss'
import s from './summary-divider.scss'

export const SummaryDivider = ({compact}: {compact?: boolean}) => (
  <div className={classNames(s.divider, c.formSummaryDivider, {[s.compact]: compact})} />
)
